module.exports = require("js-yaml");


//////////////////
// WEBPACK FOOTER
// external "js-yaml"
// module id = 47
// module chunks = 0 1 2 3 4 5 6 7 8 9